<!-- New UI --->
<div class="live-person-container">
    @if (DASModalEnabled()) {
        <ng-container
            *ngTemplateOutlet="liveChatButtonContainer ; context: { $implicit: data }"
        ></ng-container>
    } @else {
        <ng-container
            *ngTemplateOutlet="showLogin() ? login : spinner ; context: { $implicit: data }"
        ></ng-container>
    }
    <!-- Let Live person take control -->
    <div [attr.id]="data.containerId" #container
        class="lp-button-container"
        [class.hidden]="DASModalEnabled()"
        (finderElementChange)="removeSpinner()">
    </div>
</div>

<ng-template #spinner let-data>
    @if (loading) {
        <finder-loading-spinner></finder-loading-spinner>
    }
</ng-template>

<!-- Login Button -->
<ng-template #login let-data>
    <ng-container
        *ngTemplateOutlet="data.enabled ? loginButton : disabledButton; context: { $implicit: data }"
    ></ng-container>
</ng-template>

<ng-template #liveChatButtonContainer let-data>
    <ng-container
        *ngTemplateOutlet="data.enabled ? liveChatButton : disabledButton; context: { $implicit: data }"
    ></ng-container>
</ng-template>

<!-- Disabled State -->
<ng-template #disabledButton let-data>
    <finder-tooltip [id]="'live-person-tooltip'"
        [position]="'top'"
        [tooltip]="data.labels?.tooltip?.text"
        [title]="data.labels?.tooltip?.title"
    >
        <ng-container
            *ngTemplateOutlet="loginButton; context: { $implicit: data }"
        ></ng-container>
    </finder-tooltip>
</ng-template>

<!-- Enabled State -->
<ng-template #loginButton let-button>
    <finder-button
        (click)="checkLogin($event)"
        [disabled]="!data.enabled"
        [theme]="loggedIn() ? 'primary' : 'secondary'">
        {{data.button?.text}}
    </finder-button>
</ng-template>

<ng-template #liveChatButton let-button>
    <finder-button
        (click)="checkLogin($event)"
        [disabled]="!data.enabled"
        [theme]="loggedIn() ? 'primary' : 'secondary'">
        {{data.button?.text}}
    </finder-button>
</ng-template>
